import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'resetCustomerRDChequeStatus',
  components: {
    
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      appData: {
        issuedRDChequesCount: 0,
        lastRDChequeNumber: '',
        lastRDChequeDate: ''
      },
      lang: ''
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('reset_customer_RD_cheque_status_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.appData = this.dataObj.appData;
      });
    },
  },
}
